// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const getInitialState = () => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  
  return {
    user: userStr ? JSON.parse(userStr) : null,
    token: token,
    isAuthenticated: !!token,
    loading: false,
    error: null,
    sessionExpired: false,
  };
};

const authSlice = createSlice({
  name: 'auth',
  initialState: getInitialState(),
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.sessionExpired = false;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.error = null;
      state.sessionExpired = false;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.sessionExpired = false;
    },
    registerRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.sessionExpired = false;
    },
    registerSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.error = null;
      state.sessionExpired = false;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
    },
    registerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.sessionExpired = false;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      state.sessionExpired = false;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
    sessionExpired: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.sessionExpired = true;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
    clearSessionExpired: (state) => {
      state.sessionExpired = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  registerRequest,
  registerSuccess,
  registerFailure,
  logout,
  sessionExpired,
  clearSessionExpired,
  clearError,
} = authSlice.actions;

export default authSlice.reducer;